/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = 309
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///(webpack)/buildin/amd-options.js